import { defineWebModule } from '@clientline/contracts/web-module';

/**
 * Вебманіфест модуля пошти: лише пункт навігації (ML-W1). Екран кабінету — лінивий маршрут застосунку
 * `/mail`, лічильник непрочитаних малює оболонка.
 */
export default defineWebModule({
  id: 'mail',
  nav: [
    {
      id: 'mail.cabinet',
      label: 'i18n:nav.mail',
      route: '/mail',
      permission: 'mail.use',
      icon: 'mail',
      order: 25,
    },
  ],
});
